module.exports = __webpack_public_path__ + "img/9.bb64a981.jpg";